<div class="w-full py-3 px-4">
    <!-- Add Ready Product Title Section -->
    <div class="md:flex items-center justify-between mb-4">
        <div class="flex items-center justify-start gap-1 lg:gap-2 mb-3 lg:mb-0">
            <!-- Back Button SVG (clickable) -->
            <svg class="size-6 cursor-pointer" [routerLink]="['/home']" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">

                <mask id="mask0_848_1764" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24"
                    height="24">
                    <rect width="24" height="24" fill="#C19725" />
                </mask>
                <g mask="url(#mask0_848_1764)">
                    <path d="M16 22L6 12L16 2L17.775 3.775L9.55 12L17.775 20.225L16 22Z" fill="#C19725" />
                </g>
            </svg>
            <img class="size-6 sm:size-8 lg:size-10" src="/assets/images/stock/ready-product.png" alt="user">
            <span class="font-semibold text-sm sm:text-base lg:text-xl text-444">Add Ready Product</span>

        </div>
        <div class="flex justify-end items-center">
            <div
                class="flex w-[320px] lg:w-[380px] bg-white rounded-lg shadow-sm border border-[#D9D9D9] overflow-hidden">

                <!-- Piece -->
                <a routerLink="piece" routerLinkActive="bg-[#c19725] text-white font-medium"
                    [routerLinkActiveOptions]="{ exact: true }" class="flex-1 text-center px-4 py-2 text-sm lg:text-base text-[#898989]
             hover:bg-[#f6f1cb] hover:text-black transition-all duration-200">
                    Piece Wise
                </a>

                <!-- Lot -->
                <a routerLink="lot" routerLinkActive="bg-[#c19725] text-white font-medium"
                    [routerLinkActiveOptions]="{ exact: true }" class="flex-1 text-center px-4 py-2 text-sm lg:text-base text-[#898989]
             border-l border-[#D9D9D9]
             hover:bg-[#f6f1cb] hover:text-black transition-all duration-200">
                    Lot Wise
                </a>

                <!-- Product -->
                <a routerLink="non-jewellery-product" routerLinkActive="bg-[#c19725] text-white font-medium"
                    [routerLinkActiveOptions]="{ exact: true }" class="flex-1 text-center px-4 py-2 text-sm lg:text-base text-[#898989]
             border-l border-[#D9D9D9]
             hover:bg-[#f6f1cb] hover:text-black transition-all duration-200">
                    Product
                </a>

            </div>
        </div>

    </div>
    <router-outlet />

</div>